import { CheckboxOption } from './types';

export const checkboxOptions: CheckboxOption[] = [
  { id: 'isento', value: 'isento', label: ' Isento' },
];

export const statusOptions = [
  { value: true, label: 'Ativo' },
  { value: false, label: 'Inativo' },
];

export const CNPJ_MASK = '**.***.***/****-99';
export const CNPJ_FORMAT_CHARS: Record<string, string> = {
  '*': '[A-Za-z0-9]',
  '9': '[0-9]',
};
